import { render, staticRenderFns } from "./syncSubscribeWechat.vue?vue&type=template&id=fc1f4a84&scoped=true"
import script from "./syncSubscribeWechat.vue?vue&type=script&lang=js"
export * from "./syncSubscribeWechat.vue?vue&type=script&lang=js"
import style0 from "./syncSubscribeWechat.vue?vue&type=style&index=0&id=fc1f4a84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1f4a84",
  null
  
)

export default component.exports